import { Disclosure, Transition } from "@headlessui/react";
import React, { FC, Fragment } from "react";
import ExpandButton from "./expandButton";
import Button from "../button/button";
import { CHAIN_ID } from "../../../constants";
import Hint from "../hint/hint";

interface ExpandRowWithBtnProps {
  label?: string;
  defaultOpen?: boolean;
  keepOpen?: boolean;
  buttonText?: string;
  onClick?: (e) => void;
}

const ExpandRowWithBtn: FC<ExpandRowWithBtnProps> = ({
  label,
  buttonText,
  defaultOpen = false,
  keepOpen = false,
  onClick,
  children,
}) => {
  const handleClick = (e) => {
    //Prevents the content click event
    e.stopPropagation();

    onClick(e);
  };

  return (
    <Disclosure as="div" defaultOpen={defaultOpen} className="flex flex-col">
      {({ open }) => (
        <>
          <ExpandButton label={label} isOpen={open} keepOpen={keepOpen}>
            {/* TODO: remove this after public launch */}
            <div className="hidden md:block">
              {
                <Button size="md" fill={false} onClick={handleClick}>
                  {buttonText}
                </Button>
              }
            </div>
          </ExpandButton>
          <Disclosure.Panel className="text-white pt-16 md:pt-24 transition duration-300 ease-in-out">
            <Transition
              as="div"
              show={open}
              enter="transform transition duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transform duration-300 transition ease-in-out"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              {children}
            </Transition>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default ExpandRowWithBtn;
